const generateQueryString = (params = {}) => {
  const paramKeys = Object.keys(params);
  if (paramKeys.length <= 0) {
    return '';
  }
  return `?${Object.keys(params).filter(key => params[key] !== undefined).map(key => `${encodeURIComponent(key)}=${encodeURIComponent(params[key])}`).join('&')}`;
};
export default generateQueryString;